var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 155,
    viewBox: "0 0 126 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2303_1861)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.158 67.1695C128.158 69.8358 125.996 71.9971 123.33 71.9971H111.809C110.359 71.9971 108.958 72.5189 107.862 73.467L101.351 79.0971C99.5829 80.6665 97.3423 81.4559 95.0922 81.4559C92.8232 81.4559 90.5354 80.6523 88.7107 79.0309L82.4372 73.5003C81.335 72.5285 79.9161 71.9924 78.4466 71.9924H66.8071C64.1409 71.9924 61.9795 69.831 61.9795 67.1648V32.0444C61.9795 25.403 67.3825 20 74.0239 20H116.113C122.755 20 128.158 25.403 128.158 32.0444V67.1695ZM66.908 105.086C59.0754 105.086 52.727 98.7378 52.727 90.9052C52.727 83.0725 59.0754 76.7241 66.908 76.7241C74.7407 76.7241 81.0891 83.0725 81.0891 90.9052C81.0891 98.7378 74.7407 105.086 66.908 105.086ZM76.3621 114.54C81.5854 114.54 85.8161 118.771 85.8161 123.994V133.448H48V123.994C48 118.771 52.2307 114.54 57.454 114.54H76.3621ZM108.245 90.9052C108.245 98.7378 114.593 105.086 122.426 105.086C130.258 105.086 136.607 98.7378 136.607 90.9052C136.607 83.0725 130.258 76.7241 122.426 76.7241C114.593 76.7241 108.245 83.0725 108.245 90.9052ZM141.334 123.994C141.334 118.771 137.103 114.54 131.88 114.54H112.972C107.748 114.54 103.518 118.771 103.518 123.994V133.448H141.334V123.994Z",
    fill: "url(#paint0_linear_2303_1861)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 34C73.4477 34 73 34.4477 73 35C73 35.5523 73.4477 36 74 36H116C116.552 36 117 35.5523 117 35C117 34.4477 116.552 34 116 34H74ZM78 44C77.4477 44 77 44.4477 77 45C77 45.5523 77.4477 46 78 46H112C112.552 46 113 45.5523 113 45C113 44.4477 112.552 44 112 44H78Z",
    fill: "#170F1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2303_1861",
    x1: 48,
    y1: 76.7241,
    x2: 141.334,
    y2: 76.7241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2303_1861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 155,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion2);
export default __webpack_public_path__ + "static/media/Union2.1491a62207372582ad29b1e9e5b01ded.svg";
export { ForwardRef as ReactComponent };